// Type declarations for the deprecated getPropertyCSSValue() CSSOM API. This
// API has been dropped from the standards, but it's still supported by Safari.
// See here for documentation:
//   https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration/getPropertyCSSValue

export enum CSSValueType {
  CSS_INHERIT = 0,
  CSS_PRIMITIVE_VALUE = 1,
  CSS_VALUE_LIST = 2,
  CSS_CUSTOM = 3,
}

export enum CSSPrimitiveType {
  CSS_UNKNOWN = 0,
  CSS_NUMBER = 1,
  CSS_PERCENTAGE = 2,
  CSS_EMS = 3,
  CSS_EXS = 4,
  CSS_PX = 5,
  CSS_CM = 6,
  CSS_MM = 7,
  CSS_IN = 8,
  CSS_PT = 9,
  CSS_PC = 10,
  CSS_DEG = 11,
  CSS_RAD = 12,
  CSS_GRAD = 13,
  CSS_MS = 14,
  CSS_S = 15,
  CSS_HZ = 16,
  CSS_KHZ = 17,
  CSS_DIMENSION = 18,
  CSS_STRING = 19,
  CSS_URI = 20,
  CSS_IDENT = 21,
  CSS_ATTR = 22,
  CSS_COUNTER = 23,
  CSS_RECT = 24,
  CSS_RGBCOLOR = 25,
  CSS_VW = 26,
  CSS_VH = 27,
  CSS_VMIN = 28,
  CSS_VMAX = 29,
}

export type CSSInheritValue = {
  cssValueType: CSSValueType.CSS_INHERIT;
  cssText: string;
};

export type CSSPrimitiveValue = {
  cssValueType: CSSValueType.CSS_PRIMITIVE_VALUE;
  cssText: string;
  primitiveType: CSSPrimitiveType;
  getCounterValue(): any;
  getFloatValue(unit: number): number;
  getRectValue(): any;
  getRGBColorValue(): any;
  getStringValue(): string;
};

export type CSSValueList = {
  cssValueType: CSSValueType.CSS_VALUE_LIST;
  cssText: string;
  item(index: number): CSSValue | null;
  length: number;
};

export type CSSCustomValue = {
  cssValueType: CSSValueType.CSS_CUSTOM;
  cssText: string;
};

export type CSSValue = CSSInheritValue | CSSPrimitiveValue | CSSValueList | CSSCustomValue;

export type CSSStyleDeclarationWithCSSValue = CSSStyleDeclaration & {
  getPropertyCSSValue?: (name: string) => CSSValue;
};
